var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',[_c('b-row',[_c('h3',{staticClass:"notAllowed text-center"},[_vm._v("Su cuenta ya ha sido verificada. Puede acceder a todos los contenidos de nuestra web.😊")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }